<div class="menu-horizontal-submenu">
  <ng-container *ngFor="let child of children">
    <a *appHasRole="child.roles"
       [routerLink]="child.link"
       class="menu-horizontal-submenu__link"
       [class.active]="isRouteActive(child)"
       (click)="close()">
      <span class="menu-horizontal-submenu__icon" [ngClass]="child.icon"></span>
      <span class="menu-horizontal-submenu__name">{{ child.name }}</span>
    </a>
  </ng-container>
</div>
